import Fragment from "./fragment";
import FragmentSummary from "./fragment-summary";

export default class OnSide extends Fragment {
    constructor() {
        super();
        this.code = "ONSIDE";
    }

    summarize(summaryContext, stringifier) {
        const niceKickedOffBallSpot = stringifier.niceFieldPosition(
            summaryContext.gameConfig.general.fieldLength,
            summaryContext.kickedOffBallSpot,
            summaryContext.homeTeam?.abbrName,
            summaryContext.awayTeam?.abbrName
        );
        return new FragmentSummary(` to ${niceKickedOffBallSpot}`);
    }
}
